import type { FieldId } from '../../../../common/types/field.tsx';
import type { ChangeId, RegisteredFieldsMap } from '../../types.tsx';

export const fieldWasRegistered = (
	registeredFields: RegisteredFieldsMap,
	changeId: ChangeId,
	fieldId: FieldId,
	appId: string,
) => !!registeredFields[appId]?.[changeId]?.includes(fieldId);
